import { render, staticRenderFns } from "./FxWallet.vue?vue&type=template&id=e2c15ae0&scoped=true"
import script from "./FxWallet.vue?vue&type=script&lang=js"
export * from "./FxWallet.vue?vue&type=script&lang=js"
import style0 from "./FxWallet.vue?vue&type=style&index=0&id=e2c15ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c15ae0",
  null
  
)

export default component.exports